import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerQueryStatus } from 'src/app/core/models/PartnerQueryStatus';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { AdminService } from '../../admin/admin.service';
import { UserService } from 'src/app/core/services/user.service';
import { ApplicationRole } from 'src/app/core/models/ApplicationRole';
import { openViewAttachmentsModal, openViewCommentsModal } from '../Shared/CommonHelper';
import { NzModalService } from 'ng-zorro-antd/modal';


@Component({
  selector: 'app-internal-user-view-query',
  standalone: false,
  templateUrl: './internal-user-view-query.component.html',
  styleUrl: './internal-user-view-query.component.less'
})
export class InternalUserViewQueryComponent {
  @Input() currentUser1!: User;
  @Input() queryModel!: QueryModel;

  currentUser: User = new User();
  queryCode: number = 0;

  queryStatus: QueryStatus = QueryStatus.New;
  partnerQueryStatus: PartnerQueryStatus = PartnerQueryStatus.New;
  dropdownSettings = {};
  partnerUserMaster: { item_id: any; item_text: any }[] = [];
  CCSubDepartmentsMaster: { item_id: any; item_text: any }[] = [];
  selectedCCUsers: number[] = [];
  selectedCCSubDepts: number[] = [];

  isCategoryCommentVisible = false;
  isContractNumberVisible = false;
  isAFEVisible = false;
  isWOVisible = false;
  isSIOPVisible = false;

  canViewDeletedComment = false;

  partnerUploadedAttachmtCnt = 0;
  internalUserUploadedAttachmtCnt = 0;

  queryNewEnum = QueryStatus.New;
  queryReOpenedEnum = QueryStatus.ReOpened;
  queryResponseEnum = QueryStatus.Responded;

  constructor(
    private router: Router,
    private route: ActivatedRoute,   
    private adminService : AdminService,
    private userService : UserService,
    private modalService: NzModalService,
  ) { 
    this.queryCode = +(this.route.snapshot.paramMap.get('queryCode') ?? 0);
  }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    this.initialiseData();
    if (this.queryCode == 0) {
      this.router.navigate(['/']);
    }
    else {
      this.adminService.getAllRegisteredPartners().subscribe({
        next: (response) => {
          if (response.output && response.output.length > 0) {
            this.partnerUserMaster = response.output.map((partner:any) => ({
              item_id: partner.User_Code,
              item_text: partner.User_Name
            }));
            this.selectedCCUsers = this.queryModel.QueryDetail.CCUsers;
          }
        },
        error: (error) => {
          console.error('Error occurred while fetching registered partners:', error);
          this.redirectToQueryRequest();
        }
      });

      this.adminService.getAllSubDeptMapping().subscribe((response: any) => {
        if (response.output.length > 0) {
          for (var i = 0; i < response.output.length; i++) {
            this.CCSubDepartmentsMaster.push({ item_id: response.output[i].Sub_Dept_Code, item_text: response.output[i].Department_Name +' - ' + response.output[i].Sub_Dept_Name});
          }
          this.selectedCCSubDepts = this.queryModel.QueryDetail.CCSubDepartments;
          
        }        
      }, error => {
        //this.toastrService.error("Error occurred while fetching the query details", 'Notification');
        console.log(error);
        this.redirectToQueryRequest();
      });
    }
  }
  initialiseData() {
    this.partnerUserMaster = [];
    this.setSubCategoryVisibility(this.queryModel.QueryDetail.Clarification_SubCat_Code);
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
    };
    if (this.queryModel.QueryStatusEnum == QueryStatus.DeletedByPartner
      || this.queryModel.QueryStatusEnum == QueryStatus.DeletedByRFCAdmin) {
      this.canViewDeletedComment = true;
    }

    this.partnerUploadedAttachmtCnt = this.queryModel.QueryDetail.FileAttachments.filter(s => s.Partner_UploadedFile).length;
    this.internalUserUploadedAttachmtCnt = this.queryModel.QueryDetail.FileAttachments.filter(s => !s.Partner_UploadedFile).length;
  }
  setSubCategoryVisibility(SubCategory_Code: string) {
    switch (SubCategory_Code.toString()) {
      case "1":
      case "5":
        this.isContractNumberVisible = true;
        break;
      case "2":
      case "6":
        this.isAFEVisible = true;
        break;
      case "3":
      case "7":
        this.isWOVisible = true;
        break;
      case "4":
      case "8":
        this.isCategoryCommentVisible = true;
        break;
    }
  }
  viewAttachments(viewPartnerUploadedFiles: boolean) {
    this.queryModel.QueryDetail.Query_Reference_Number = this.queryModel.Query_Reference_Number;
    openViewAttachmentsModal(this.modalService, this.queryModel.QueryDetail, viewPartnerUploadedFiles);
    //this.commonHelper.viewAttachments(viewPartnerUploadedFiles, this.queryModel.QueryDetail);
    // const modalRef = this.modalService.open(ViewAttachmentsComponent, {
    //   backdrop: 'static',
    //   keyboard: false,
    //   size: 'lg'
    // });
    // var fileAttachments = this.queryModel.QueryDetail.FileAttachments.filter(s => s.Partner_UploadedFile == viewPartnerUploadedFiles)
    // modalRef.componentInstance.fileAttachments = fileAttachments;
    // modalRef.componentInstance.queryReferenceNumber = this.queryModel.Query_Reference_Number;
    // modalRef.componentInstance.queryCode = this.queryModel.Clarification_Query_Code;
    // modalRef.componentInstance.queryDetailCode = this.queryModel.QueryDetail.Clarification_Query_Detail_Code;
    // modalRef.result.then((result) => {
    //   modalRef.dismiss();
    // }, (reason) => {
    //   console.log(reason);
    // });
  }

  viewComments() {
    openViewCommentsModal(this.modalService, this.queryModel.Query_Reference_Number, this.queryModel.QueryDetail.ConsolidatedComment);
    // const modalRef = this.modalService.open(ViewCommentsComponent, {
    //   backdrop: 'static',
    //   keyboard: false,
    //   size: 'lg'
    // });
    // modalRef.componentInstance.queryComments = this.queryModel.QueryDetail.ConsolidatedComment;
    // modalRef.componentInstance.queryReferenceNumber = this.queryModel.Query_Reference_Number;
    // modalRef.result.then((result) => {
    //   modalRef.dismiss();
    // }, (reason) => {
    //   console.log(reason);
    // });
  }
  redirectToQueryRequest() {
    //this.router.navigate((this.currentUser.IsRFCAdmin) ? ['/clarification-query/all-query'] : ['/clarification-query/my-query'])
    this.router.navigate((this.currentUser.IsRFCAdmin || this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.DeptViewer) !== -1
      ) ? ['/clarification-query/all_query_request'] : ['/clarification-query/my-query'])
  }
}
